module.exports = __webpack_public_path__ + "assets/img/warrior-name-1a809253.png";